import React from 'react'
import PropTypes from 'prop-types'

const PreviewPlayIcon = ({ width, height, title }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 40"
    // fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1.17188" y="0.75" width="38.5" height="38.5" rx="19.25" fill="#151515" fillOpacity="0.6" stroke="currentColor" strokeWidth="1.5" />
    <path d="M15.9775 13L26.8664 20L15.9775 27V13Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

PreviewPlayIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.string,
}

PreviewPlayIcon.defaultProps = {
  width: 41,
  height: 40,
  title: 'Menu',
}

export default PreviewPlayIcon
